<template>
  <Drawer
    v-model="drawerOpened"
    :title="salesOrder ? salesOrder.sales.abbr : ''"
    width="450"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem
          label="退货类型"
          prop="returnType"
        >
          <Select
            v-model="formItem.returnType"
            style="width:200px"
          >
            <Option
              v-for="item in returnTypeList"
              :value="item.value"
              :key="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="退货数量（吨）"
          prop="volReturn"
        >
          <InputNumber
            v-model="formItem.volReturn"
            placeholder="填写退货数量（吨）"
            style="width:150px"
          />
        </FormItem>
        <FormItem
          label="退货原因"
          prop="returnReason"
        >
          <Input
            type="textarea"
            v-model="formItem.returnReason"
            style="width:366px"
            placeholder="填写退货原因"
          />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
          >退货</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";

export default {
  name: "SalesOrderReturnDrawer",
  props: {},
  data() {
    return {
      drawerOpened: false,
      salesOrder: null,
      formItem: {
        returnType: null,
        volReturn: null,
        returnReason: null,
      },
      returnTypeList: [
        {
          value: "full",
          label: "打不下",
        },
        {
          value: "quality",
          label: "质量问题",
        },
        {
          value: "others",
          label: "其它",
        },
      ],
      ruleValidate: {
        returnType: [
          { required: true, message: "退货类型为必填项", trigger: "submit" },
        ],
        volReturn: [
          {
            required: true,
            message: "退货数量为必填项",
            trigger: "submit",
            type: "number",
          },
        ],
        returnReason: [
          { required: true, message: "退货原因为必填项", trigger: "submit" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    arrayIntersection() {
      return arrayIntersection;
    },
    ...mapActions({
      getUserList: "user/getUsersAction",
      salesOrderReturn: "salesOrder/salesOrderReturnAction",
    }),

    openDrawer(salesOrder) {
      this.drawerOpened = true;
      console.log(salesOrder);
      if (salesOrder) {
        this.salesOrder = salesOrder;
      }
    },
    async handleSubmit(name) {
      this.$refs[name].validate(async (vaild) => {
        if (vaild) {
          try {
            console.log(this.formItem);
            await this.salesOrderReturn({
              id: this.salesOrder._id,
              data: this.formItem,
            });
            this.$Message.success("退货成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error("退货失败!");
          }
        }
      });
    },
  },
  async created() {},
};
</script>

<style scoped lang="stylus">
@import './EditDeliveryDrawer.styl'
</style>
